import apiFetch from '../../apiFetch'

export default function (dealerNumber, customer, token) {
  return apiFetch({ endPoint: `Vehicle/Quiter/${customer}`, method: 'GET', token: token, dealerNumber: dealerNumber })
}
